import differenceInWeeks from 'date-fns/differenceInWeeks';

export function getDifferenceInWeeks(firstDate, secondDate) {
  return differenceInWeeks(firstDate, secondDate);
}
